// eslint-disable-next-line import/prefer-default-export
export enum WaitingLineFormPages {
  TYPE_SELECTION = 0,
  CONFIGURATION = 1,
  TRANSLATIONS = 2,
}
